var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button-group',{staticClass:"galaxy-history-functions"},[_vm._t("default",null,{"item":_vm.item})],2)}
var staticRenderFns = []

export { render, staticRenderFns }